import { getMe, getOrCreateCode, previewCode } from "@/generated/api/sdk.gen"
import type { Api } from "@/platform/api/api"
import { body } from "@/platform/api/gateways/common"

export const referralsGateway = (api: Api) => ({
  me: () => body(getMe(api.request())),

  codeOffer: (code: string) => body(previewCode({ ...api.request({ credentials: "public" }), path: { code } })),

  getOrCreateCode: () => body(getOrCreateCode(api.request())),
})

export type ReferralsGateway = ReturnType<typeof referralsGateway>
